import script from "./PointsAudit.vue?vue&type=script&setup=true&lang=js"
export * from "./PointsAudit.vue?vue&type=script&setup=true&lang=js"

import "./PointsAudit.vue?vue&type=style&index=0&id=92104604&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92104604"]])

export default __exports__